import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.config.productionTip = false

import fetch from '@/utils/fetcher/http.interceptor.js'
Vue.prototype.$fetch = fetch;
Vue.prototype.$appName = process.env.VUE_APP_NAME;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
